import type { ExperimentStatus, Ratio } from '../../netlify/functions/_lib/domain.ts';

/** Page copy for the days-elapsed metric. Archived has no clock; do not show 0.0 as time. */
export function daysElapsedMetric(input: {
  status: ExperimentStatus;
  daysElapsed: number;
  conversionLabel: string;
  conversionRate: Ratio | null;
}): { value: string; hint: string } {
  if (input.status === 'archived') {
    return {
      value: '—',
      hint: 'An archived experiment does not age. There is no clock.',
    };
  }

  if (input.status !== 'running' && input.status !== 'decided') {
    return {
      value: input.daysElapsed.toFixed(1),
      hint: 'Days start when the experiment is running or decided. A draft does not age.',
    };
  }

  return {
    value: input.daysElapsed.toFixed(1),
    hint: input.conversionRate
      ? `${input.conversionLabel} / clicks: ${input.conversionRate.directional ? 'directional ' : ''}${input.conversionRate.numerator}/${input.conversionRate.denominator}`
      : 'No click-to-conversion ratio yet.',
  };
}
